import { render, staticRenderFns } from "./gtr-color-picker.vue?vue&type=template&id=b921304e"
import script from "./gtr-color-picker.ts?vue&type=script&lang=ts&external"
export * from "./gtr-color-picker.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports